<script lang="ts">
    import Spinner from "../leafElement/Spinner.svelte";
    import Select from "../leafElement/Select.svelte";
    import { AppConfgiStore, DefAppConfig } from "../script/probeStore";
    import { DATA_POINT_STATE } from "../script/enum";
    import type {
        MesurmentDataPoint,
        MesurmentEnv,
        MesurmentFull,
    } from "../script/types";
    import type { GraphData, ProbeData } from "./sub/types";
    import { createEventDispatcher, onDestroy } from "svelte";
    import CheckBox from "../leafElement/CheckBox.svelte";
    import SmallTable from "../wrapElement/SmallTable.svelte";
    import { getMinSuf_wholeNum, getSecSuf_wholeNum } from "../script/common";
    import { newDataPointPushUp } from "./sub/DPTsub";
    import { formatRecValToDispForm } from "./dataParser";
    import Input from "../leafElement/Input.svelte";

    const dispatch = createEventDispatcher();

    /* const PREV_WIKA_TIMER = 2000;
    const DISABLE_CHECK_UPDATE = 3000;
    const DISPLAY_MIN_TREASHOLD_TRHEASHOLD = 60_000; */
    const MIN_TO_SEC = 60;

    const AUTO_MODE = 0;
    const ETHALON_MANUAL_MODE = 1;
    const INVALID_DISPLAYED_REC: [number, string] = [0, "✖"];

    interface Mesurment {
        targetTemp: number;
        dataFullLen: number;
        probeFullLen: number;
        curRecords: number;
        recordValidity: {
            ethanolValid: boolean;
            probeCountValid: number;
            probeValidMap: { [key: string]: boolean };
        };
        mesurmentStart: Date;
        mesurmentEnded: Date | null;
        // probeCount: number; // TODO
        probeMesData: MesurmentFull[];
        data: {
            ethanol: [number, number];
            ethanol_disp: [number, string];
            probe: [number, number][];
            probe_disp: [number, string][];
            TS: number;
        }[];
    }

    export let env: MesurmentEnv;
    let AppConfig = DefAppConfig;
    AppConfgiStore.subscribe((appConf) => {
        AppConfig = appConf;
    });

    let owerideActionsChecks = false;
    let disableActions = false;
    let disableAllCheck = false;
    let disableLongTimer = false;
    let disableNoDataReceved = false;
    $: disableActions = !(
        env &&
        (owerideActionsChecks ||
            (!disableAllCheck && !disableLongTimer && !disableNoDataReceved))
    );

    let wikaDinData: GraphData;
    let probeDinData: ProbeData[] = [];
    let wikaDataWriteableSub;
    export let wikaDataWriteable;
    let probeDataWriteableSub;
    export let probeDataWriteable;
    $: {
        if (wikaDataWriteableSub) wikaDataWriteableSub();
        wikaDataWriteableSub = wikaDataWriteable.subscribe((data) => {
            if (!data) return;
            wikaDinData = data;
        });
    }
    $: {
        if (probeDataWriteableSub) probeDataWriteableSub();
        probeDataWriteableSub = probeDataWriteable.subscribe((dataList) => {
            if (!dataList) return;
            probeDinData = dataList;
            recomputeChecks(dataList);
        });
    }
    function recomputeChecks(data: ProbeData[]) {
        disableAllCheck = !data.reduce((ac, val) => ac && val.checked, true);
        disableLongTimer = !data.reduce(
            (ac, val) =>
                ac &&
                Boolean(
                    new Date().getTime() - val.last[0] <
                        AppConfig.mesurmentParam.inactiveTimeToWarn * 1000
                ),
            true
        );
        disableNoDataReceved = !data.reduce(
            (ac, val) => ac && !isNaN(val.last[1]),
            true
        );
    }

    let avalibleTemp = [];
    let selectedTemp: { temp: number; hum: number } | null = null;
    $: avalibleTemp = env
        ? env.group.targetDataPoints
              .filter((val) => val.state !== DATA_POINT_STATE.fin)
              .map((val) => {
                  return {
                      name: `${val.temp}°C`,
                      value: {
                          temp: val.temp,
                          hum: val.hum,
                      },
                  };
              })
        : [];

    let selectedDTTakingMode = AUTO_MODE;
    let avalibleDTTakingMode = [
        {
            name: "Plně automatický",
            value: AUTO_MODE,
        },
        {
            name: "Částečně automatický",
            value: ETHALON_MANUAL_MODE,
        },
    ];

    let lastMesurment: Mesurment;
    let mesInProgresDestructor: () => void;
    let resMesStart: Date | null;
    let mesurmentCounter: number;
    let mesCounterIntervalId;
    let dbComunicationFailed = false;
    let dbComunicationFailedTimer;

    let ethalonManualValNativeElement;
    let ethanolMalualVal: number = null;
    let acceptNewEthalonForMesurment: (value: number) => void;

    let owerideMesurmentValidity = false;

    function idDataRecordValid(dr: [number, number]) {
        return (
            !isNaN(dr[1]) &&
            dr[1] !== null &&
            dr[1] !== undefined &&
            new Date().getTime() - dr[0] <
                AppConfig.mesurmentParam.inactiveTimeToWarn * 1000
        );
    }

    function startAutoMesurnemt_sub(
        mesurment: Mesurment,
        recolve: (val: Mesurment) => void
    ) {
        takeValue(mesurment);
        refreshTable(mesurment); // TODO
        if (mesurment.curRecords >= AppConfig.mesurmentParam.count) {
            recolve(mesurment);
        }
        let intervalId;
        mesInProgresDestructor = () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
        intervalId = setTimeout(
            () => startAutoMesurnemt_sub(mesurment, recolve),
            AppConfig.mesurmentParam.interval * 1000
        );
    }

    async function startAutoMesurnemt(
        mesurment: Mesurment
    ): Promise<Mesurment> {
        return new Promise((recolve, _) => {
            resMesStart = new Date();
            mesCounterIntervalId = setInterval(() => {
                mesurmentCounter =
                    Math.floor(
                        AppConfig.mesurmentParam.interval -
                            (new Date().getTime() - resMesStart.getTime()) /
                                1000
                    ) + 1;
            }, 500);
            startAutoMesurnemt_sub(mesurment, recolve);
        });
    }
    async function starEthanoltManualMesurment(
        mesurment: Mesurment
    ): Promise<Mesurment> {
        return new Promise((resolve, _) => {
            mesInProgresDestructor = () => {
                acceptNewEthalonForMesurment = null;
            };
            acceptNewEthalonForMesurment = (ethVal) => {
                const nowTime = new Date().getTime();
                takeFullValue(
                    mesurment,
                    [nowTime, ethVal],
                    [nowTime, formatRecValToDispForm(ethVal)]
                );
                refreshTable(mesurment); // TODO
                console.log(
                    mesurment.curRecords,
                    AppConfig.mesurmentParam.count
                );
                if (mesurment.curRecords >= AppConfig.mesurmentParam.count) {
                    resolve(mesurment);
                    acceptNewEthalonForMesurment = null;
                }
            };
        });
    }

    function saveEthanolValue() {
        if (disableActions || ethanolMalualVal === null) return;
        const ethVal = ethanolMalualVal;
        ethanolMalualVal = null;
        if (!acceptNewEthalonForMesurment) {
            console.warn("No fun for ethanol handle");
        }
        acceptNewEthalonForMesurment(ethVal);
        if (ethalonManualValNativeElement) {
            ethalonManualValNativeElement.focus();
        }
    }

    function takeValue(mesurment: Mesurment) {
        const lastEthonolValueValid = idDataRecordValid(wikaDinData.last);
        if (!lastMesurment) {
            mesurment.recordValidity.ethanolValid = false;
        }
        return takeFullValue(
            mesurment,
            lastEthonolValueValid ? wikaDinData.last : [null, null],
            lastEthonolValueValid
                ? wikaDinData.last_disp
                : INVALID_DISPLAYED_REC
        );
    }
    function takeFullValue(
        mesurment: Mesurment,
        realVal: [number, number],
        dispVal: [number, string]
    ) {
        mesurment.data.push({
            ethanol: realVal,
            ethanol_disp: dispVal,
            probe: probeDinData.map((probe) => {
                const lastProbeValueValid = idDataRecordValid(probe.last);
                if (
                    !lastProbeValueValid &&
                    mesurment.recordValidity.probeValidMap[probe.idKlt]
                ) {
                    mesurment.recordValidity.probeValidMap[probe.idKlt] = false;
                    mesurment.recordValidity.probeCountValid--;
                }
                return lastProbeValueValid ? probe.last : [null, null];
            }),
            probe_disp: probeDinData.map((probe) => {
                const lastProbeValueValid = idDataRecordValid(probe.last);
                return lastProbeValueValid
                    ? probe.last_disp
                    : INVALID_DISPLAYED_REC;
            }),
            TS: new Date().getTime(),
        });
        mesurment.curRecords = mesurment.curRecords + 1; // needed
        mesurmentCounter = 0;
        resMesStart = new Date();
    }

    function endMesurmentAndSave() {
        const mesurmentList: {
            mes: MesurmentFull;
            data: MesurmentDataPoint;
        }[] = [];
        for (let i = 0; i < lastMesurment.probeMesData.length; i++) {
            mesurmentList.push({
                mes: lastMesurment.probeMesData[i],
                data: {
                    meta: {
                        targetTemp: lastMesurment.targetTemp,
                        targetHum: NaN, // TODO
                        mesurmentStartTS:
                            lastMesurment.mesurmentStart.getTime(),
                        mesurmentEndTS: lastMesurment.mesurmentEnded.getTime(),
                    },
                    dataPoints: lastMesurment.data.map((mes, j) => {
                        return {
                            sequenceId: j,
                            etalonValue: mes.ethanol[1],
                            probeValue: mes.probe[i][1],
                            TS: mes.TS,
                        };
                    }),
                },
            });
        }
        // console.log("[INFO - New Mesurment]:", dataPointDescription);
        newDataPointPushUp(mesurmentList).then((sucess) => {
            if (sucess) {
                const usedTemp = lastMesurment.targetTemp;
                endMesurmentWithouSafe();
                dispatch("newDT", {
                    temp: usedTemp,
                    val: DATA_POINT_STATE.fin,
                });
                // required for select update
                const dataPointDescription = env.group.targetDataPoints.filter(
                    (val) => val.temp === usedTemp
                );
                dataPointDescription.forEach((val) => {
                    val.state = DATA_POINT_STATE.fin;
                    val.finishCount = val.probeCount;
                });
                env.group.targetDataPoints = [...env.group.targetDataPoints];
            } else {
                dbComunicationFailed = true;
                if (dbComunicationFailedTimer)
                    clearTimeout(dbComunicationFailedTimer);
                dbComunicationFailedTimer = setTimeout(() => {
                    dbComunicationFailed = false;
                });
            }
        });
    }

    function endMesurmentWithouSafe() {
        stopCurentMesurment();
        if (dbComunicationFailedTimer) clearTimeout(dbComunicationFailedTimer);
        dbComunicationFailed = false;
        selectedTemp = null;
        ethanolMalualVal = null;
        lastMesurment = null;
    }

    function stopCurentMesurment() {
        if (mesInProgresDestructor) mesInProgresDestructor();
        mesInProgresDestructor = null;
        if (mesCounterIntervalId) clearInterval(mesCounterIntervalId);
        resMesStart = null;
        mesurmentCounter = 0;
    }

    const mesurmentFun_SL = {
        data: [],
    };
    let mesurmentLen_SL = 0;
    let mesurment_SL = [];
    $: refreshTable(lastMesurment);

    function refreshTable(mesurment: Mesurment) {
        mesurmentLen_SL = mesurment ? mesurment.dataFullLen : 0;
        mesurment_SL = mesurment
            ? [
                  {
                      showHeadder: true,
                      row: [
                          {
                              title: "Id",
                              val: "Etalon",
                          },
                          ...getMesurmentDT(mesurment.dataFullLen, -1), // get wika data
                      ],
                  },
                  ...probeDinData.map((probe, i) => {
                      return {
                          showHeadder: false,
                          row: [
                              {
                                  title: "Id",
                                  val: probe.name,
                              },
                              ...getMesurmentDT(mesurment.dataFullLen, i),
                          ],
                      };
                  }),
              ]
            : [];
    }

    function getMesurmentDT(mesuretimes, probeId) {
        const ret = [];
        for (let i = 0; i < mesuretimes; i++) {
            ret.push({
                title: `Náměr ${i + 1}.`,
                val: `${
                    i >= lastMesurment.data.length
                        ? "— —"
                        : probeId == -1
                        ? lastMesurment.data[i].ethanol_disp[1]
                        : lastMesurment.data[i].probe_disp[probeId][1]
                }°C`,
            });
        }
        return ret;
    }

    async function initMesurment() {
        stopCurentMesurment();
        const mesurment: Mesurment = {
            targetTemp: selectedTemp.temp,
            dataFullLen: AppConfig.mesurmentParam.count,
            probeFullLen: probeDinData.length,
            curRecords: 0,
            recordValidity: {
                ethanolValid: true,
                probeCountValid: probeDinData.length,
                probeValidMap: probeDinData.reduce((acc, val) => {
                    acc[val.idKlt] = true;
                    return acc;
                }, {}),
            },
            probeMesData: probeDinData.map((val) => val.mes),
            mesurmentStart: new Date(),
            mesurmentEnded: null,
            data: [],
        };
        lastMesurment = mesurment;
        if (selectedDTTakingMode === ETHALON_MANUAL_MODE) {
            await starEthanoltManualMesurment(lastMesurment);
        } else {
            await startAutoMesurnemt(lastMesurment);
        }
        stopCurentMesurment();
        lastMesurment.mesurmentEnded = new Date();
    }

    function cleanUp() {
        stopCurentMesurment();
        if (wikaDataWriteableSub) wikaDataWriteableSub();
        if (probeDataWriteableSub) probeDataWriteableSub();
        if (dbComunicationFailedTimer) clearTimeout(dbComunicationFailedTimer);
    }
    onDestroy(cleanUp);
</script>

<div class="root">
    <p class="bigText">Měření</p>
    <div class=" borderBox">
        <div class="controls">
            {#if disableAllCheck}
                <div class="standartdMesageCentered">
                    <div class="standartFilledMesage warningColors">
                        <span class="material-icons"> warning_amber </span>
                        <span>Nebyly zkontrolované všechny senzory</span>
                    </div>
                </div>
            {/if}
            {#if disableNoDataReceved}
                <div class="standartdMesageCentered">
                    <div class="standartFilledMesage warningColors">
                        <span class="material-icons"> warning_amber </span>
                        <span
                            >Od některých sond nebyly dosud obdrženy žádné data</span
                        >
                    </div>
                </div>
            {/if}
            {#if disableLongTimer}
                <div class="standartdMesageCentered">
                    <div class="standartFilledMesage warningColors">
                        <span class="material-icons"> warning_amber </span>
                        {#if MIN_TO_SEC < AppConfig.mesurmentParam.inactiveTimeToWarn}
                            <span
                                >Některé senzory jsou neaktivní více jak <strong
                                    >{AppConfig.mesurmentParam
                                        .inactiveTimeToWarn /
                                        MIN_TO_SEC}</strong
                                >
                                {getMinSuf_wholeNum(
                                    AppConfig.mesurmentParam.inactiveTimeToWarn
                                )}
                            </span>
                        {:else}
                            <span
                                >Některé senzory jsou neaktivní více jak {AppConfig
                                    .mesurmentParam.inactiveTimeToWarn}
                                {getSecSuf_wholeNum(
                                    AppConfig.mesurmentParam.inactiveTimeToWarn
                                )}</span
                            >
                        {/if}
                    </div>
                </div>
            {/if}
            {#if disableAllCheck || disableLongTimer}
                <div class="checkBoxWrap">
                    <p>Ignorovat varovaní</p>
                    <div>
                        <CheckBox bind:enable={owerideActionsChecks} />
                    </div>
                </div>
            {/if}
        </div>
        <div class="controls">
            <Select
                name={"Měřená teplota"}
                nullAvalible={true}
                disabled={Boolean(lastMesurment)}
                bind:userSelected={selectedTemp}
                optionsList={avalibleTemp}
            />
            <div style="margin-left: 5px;">
                <Select
                    name={"Způsob měření"}
                    disabled={Boolean(lastMesurment)}
                    bind:userSelected={selectedDTTakingMode}
                    optionsList={avalibleDTTakingMode}
                />
            </div>
            <button
                disabled={disableActions ||
                    selectedTemp === null ||
                    Boolean(lastMesurment)}
                class="standartButton"
                on:click={() => {
                    initMesurment();
                }}>Zaznamenat měření</button
            >
        </div>

        {#if lastMesurment}
            <div class="borderBox">
                <p class="bigText">Měření pro {selectedTemp.temp}°C</p>
                <div class="controls" style="margin: 7px 1rem;">
                    {#if lastMesurment.mesurmentEnded}
                        <p>Měření dokončeno</p>
                    {:else if selectedDTTakingMode === AUTO_MODE}
                        <p style="margin-right: 1rem;">
                            Další měření za: {mesurmentCounter}s
                        </p>
                        <Spinner />
                    {:else}
                        <p style="margin-right: 1rem;">
                            Počet zbývajících bodů: {lastMesurment.dataFullLen -
                                lastMesurment.curRecords}
                        </p>
                    {/if}
                </div>
                <div class="controls">
                    <button
                        disabled={Boolean(lastMesurment.mesurmentEnded)}
                        class="sgButton"
                        on:click={endMesurmentWithouSafe}
                    >
                        <span class="material-icons-outlined"> timer_off </span>
                        <span>Zastavit</span>
                    </button>
                    <button
                        disabled={!Boolean(lastMesurment.mesurmentEnded)}
                        class="sgButton"
                        on:click={endMesurmentAndSave}
                    >
                        <span class="material-icons-outlined"> save </span>
                        <span>Uložit</span>
                    </button>
                    <button
                        disabled={!Boolean(lastMesurment.mesurmentEnded)}
                        class="sgButton"
                        on:click={endMesurmentWithouSafe}
                    >
                        <span class="material-icons-outlined"> clear </span>
                        <span>Zahodit</span>
                    </button>
                    {#if !lastMesurment.recordValidity.ethanolValid}
                        <div
                            class="standartdMesageCentered"
                            style="margin-left: 25px;"
                        >
                            <div class="standartFilledMesage errorColors">
                                <span class="material-icons"> report </span>
                                <span>Nevalidní referenční data (Etanol)</span>
                            </div>
                        </div>
                    {/if}
                    {#if lastMesurment.recordValidity.probeCountValid !== lastMesurment.probeFullLen}
                        <div
                            class="standartdMesageCentered"
                            style="margin-left: 25px;"
                        >
                            <div class="standartFilledMesage warningColors">
                                <span class="material-icons">
                                    warning_amber
                                </span>
                                <span
                                    >{lastMesurment.probeFullLen -
                                        lastMesurment.recordValidity
                                            .probeCountValid} Sonda nelze exportovat</span
                                >
                            </div>
                        </div>
                    {/if}

                    {#if dbComunicationFailed}
                        <div
                            class="standartdMesageCentered"
                            style="margin-left: 25px;"
                        >
                            <div class="standartFilledMesage errorColors">
                                <span class="material-icons"> report </span>
                                <span>Spojení s databází se nepovedlo</span>
                            </div>
                        </div>
                    {/if}
                </div>
                {#if selectedDTTakingMode === ETHALON_MANUAL_MODE}
                    <div class="controls" style="margin-left: 10px;">
                        <Input
                            bind:val={ethanolMalualVal}
                            bind:nativeInput={ethalonManualValNativeElement}
                            on:enter={saveEthanolValue}
                            autoFocus={true}
                            inputType={"number"}
                            name={"Referenční teplota"}
                            required={true}
                        />
                        <button
                            disabled={disableActions ||
                                ethanolMalualVal === null}
                            class="standartButton"
                            on:click={saveEthanolValue}>Přidat bod</button
                        >
                    </div>
                {/if}

                <div class="valTable">
                    <p class="bigText">Probíhající měření</p>
                    {#if !lastMesurment}
                        <p class="smallWarning">
                            Aktuálně neprobíhá žádné měření
                        </p>
                    {/if}
                    <SmallTable
                        rowlen={mesurmentLen_SL + 1}
                        showAsGrid={true}
                        data={mesurment_SL}
                        funTable={mesurmentFun_SL}
                    />
                </div>
            </div>
        {/if}
    </div>
</div>

<style>
    .bigText {
        font-size: 1.4rem;
        padding: 0.5rem 0 0.5rem 0.7rem;
        font-weight: 300;
        color: var(--back_D2);
        user-select: all;
    }
    .controls {
        display: flex;
        align-items: center;
    }
    .valTable {
        /* margin: 1rem 10%; */
        margin: 1rem 0.5rem;
    }

    .checkBoxWrap {
        display: flex;
        margin-left: 10px;
    }
    .checkBoxWrap > p {
        font-size: 0.9rem;
        font-weight: 200;
        margin-bottom: 5px;
    }
    .checkBoxWrap > div {
        margin-left: 7px;
    }
</style>
